export default {
    data() {
        return {

        }
    },
    mounted() {
        this.$util.browseRecord(1,this)
    },
    beforeDestroy(){
        this.$util.browseRecord(2,this,this.browseId)
    },
}
